export const SET_PARTNERSHIP_CONFIG = 'SET_PARTNERSHIP_CONFIG';
export const PARTNERSHIP_API = '/api/real-estate/business/partnerConfigs';

export const setPartnershipConfig = (dispatch, getState, { get }) => {
    return dispatch(get(PARTNERSHIP_API, SET_PARTNERSHIP_CONFIG, {}));
};
